module.exports = __webpack_public_path__ + "static/fonts/OpenSans800italic.a4b64bd7.ttf";